import {
  IVisualizationState,
  IPeerGroupTabsProps,
  IFilter,
  round,
} from "../../lib/http";
import * as React from "react";
import { Panel } from "react-bootstrap";
import * as ReactHighcharts from "react-highcharts";
import * as Highcharts from "highcharts";

export class AverageTrustees extends React.Component<
  IPeerGroupTabsProps,
  IVisualizationState
  > {
  state: IVisualizationState = {
    categories: [],
    data: [],
    series: [],
    filters: { assetLevel: -1 },
    title: "",
    loading: false,
    average: [],
  };

  componentDidMount() {
    this.setState({ data: this.props.data }, () =>
      this.loadSeries(this.props.filters)
    );
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.filters.assetLevel !== this.props.filters.assetLevel ||
      prevProps.data.length !== this.props.data.length
    ) {
      this.setState(
        { filters: this.props.filters, data: this.props.data },
        () => {
          this.loadSeries(this.props.filters);
        }
      );
    }
  }

  loadSeries(filters: IFilter) {
    const { data } = this.state;

    const currentSet = data.find(
      (dataPoint) => dataPoint.filterId === filters.assetLevel
    );

    const filterOutAllFoundations = data.filter(
      (dataPoint) => dataPoint.filterId > 0
    );

    const categories = filterOutAllFoundations.map(
      (dataPoint) => dataPoint["Other_T_V16_Vis16Column"]
    );

    const selectedColor = "#0070C0";
    const nonSelectedColor = "#D9E1F2";

    const seriesData = filterOutAllFoundations.map((dataPoint) =>
      dataPoint.filterId === filters.assetLevel
        ? {
          y: parseFloat(dataPoint["Other_N_V16_AvgTrustee"].toFixed(1)) * 1.0,
          color: selectedColor,
          filterId: dataPoint.filterId,
        }
        : {
          y: parseFloat(dataPoint["Other_N_V16_AvgTrustee"].toFixed(1)) * 1.0,
          color: nonSelectedColor,
          filterId: dataPoint.filterId,
          borderWidth: 1,
          borderColor: "#a1a1a1",
        }
    );

    const title = currentSet ? currentSet["Other_T_V16_Vis16Title"] : "";

    const series = [
      {
        color: "#D9E1F2",
        name: "trustees",
        data: seriesData,
        borderWidth: 1,
        borderColor: "#a1a1a1",
      },
    ];

    this.setState({ title, series, categories });
  }

  getChartConfig(series) {
    const { categories } = this.state;
    return {
      chart: {
        type: "column",
        height: 300,
      },
      title: {
        text: "",
      },
      legend: {
        enabled: false,
      },
      xAxis: {
        categories,
      },
      yAxis: {
        visible: false,
      },
      credits: {
        enabled: false,
      },
      plotOptions: {
        column: {
          dataLabels: {
            enabled: true,
            style: {
              textOutline: false,
              fontSize: "13px",
            },
            formatter: function () {
              return Highcharts.numberFormat(this.y, 1)
            },
          },
        },
      },
      series,
    };
  }

  render() {
    const { title, loading, series } = this.state;
    return (
      <Panel>
        <div className="panel-body text-center">
          {title}
          {loading && <i className="fa fa-cog fa-spin"></i>}
        </div>
        <div className="panel-body">
          <ReactHighcharts config={this.getChartConfig(series)} ref="chart" />
        </div>
      </Panel>
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/components/visualizations/PeerGroups/Other/AverageTrustees/index.tsx